import { IGDPRConsent } from '../types/state.d';

const mapGDPRConsents = (
  consents: IGDPRConsent[],
  consentGiven: boolean,
  charityId: number,
) =>
  consents.map(consent => ({
    ConsentGiven: consent.entityType === 'Charity' ? consentGiven : true,
    ConsentStatementId: consent.id,
    EntityId: consent.entityType === 'JustGiving' ? 0 : charityId,
    ConsentStatementText: consent.text,
  }));

export default mapGDPRConsents;
